import { memo, useEffect, useRef } from "react";

const getBearing = (prev, next) => {
  if (!prev || !next) return 0;

  const lat1 = prev.latitude * (Math.PI / 180);
  const lat2 = next.latitude * (Math.PI / 180);
  const dLon = (next.longitude - prev.longitude) * (Math.PI / 180);

  const y = Math.sin(dLon) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
};

const DriverMarkers = ({
  drivers,
  onSelect,
  followTargetId,
  mapRef,
  selectedDriver,
  updateSelectedDriver,
}) => {
  const markersRef = useRef({});

  useEffect(() => {
    Object.keys(markersRef.current).forEach((id) => {
      const stillExists = drivers.some((d) => d._id === id);

      if (!stillExists) {
        const { marker } = markersRef.current[id];
        marker.map = null;
        delete markersRef.current[id];
      }
    });
  }, [drivers]);

  useEffect(() => {
    if (!mapRef.current || !window.google?.maps?.marker?.AdvancedMarkerElement)
      return;

    drivers.forEach((driver) => {
      const lat = Number(driver.location?.latitude);
      const lng = Number(driver.location?.longitude);
      if (isNaN(lat) || isNaN(lng)) return;

      const exists = markersRef.current[driver._id];

      if (!exists) {
        const img = document.createElement("img");
        img.style.width = "55px";
        img.style.transition = "transform .25s linear";
        img.style.willChange = "transform";

        const marker = new google.maps.marker.AdvancedMarkerElement({
          position: { lat, lng },
          content: img,
          map: driver.hide ? null : mapRef.current,
        });

        marker.addListener("click", () => {
          onSelect(driver._id);
        });

        markersRef.current[driver._id] = { marker, img };
      }

      const { marker, img } = markersRef.current[driver._id];

      let icon = "icons/markers/available_online_driver.png";
      if (driver.orders?.length > 0) {
        icon = driver.orders.some((o) => o.status === "5")
          ? "icons/markers/en_route_driver.png"
          : "icons/markers/pickup_driver.png";
      }
      img.src = `${process.env.REACT_APP_PUBLIC_URL}${icon}`;

      img.style.transform = `rotate(${getBearing(
        driver.prevLocation,
        driver.location,
      )}deg)`;

      marker.position = { lat, lng };

      if (driver.hide) {
        marker.map = null;
      } else {
        marker.map = mapRef.current;
      }

      if (followTargetId === driver._id && mapRef.current) {
        mapRef.current.panTo({ lat, lng });
      }
      if (
        selectedDriver?._id === driver._id &&
        updateSelectedDriver &&
        selectedDriver._marker !== marker
      ) {
        updateSelectedDriver({
          ...driver,
          _marker: marker,
          _position: { lat, lng },
        });
      }
    });
  }, [drivers, followTargetId, selectedDriver, updateSelectedDriver, mapRef]);

  return null;
};

export default memo(DriverMarkers);